export enum OrbitSetupStep {
  FORM,
  WAITING_SIGNATURE,
  VALIDATING_TRANSACTION,
  FINISHED,
  INSUFFICIENT_GAS,
  UNKNOWN_ERROR,
  DEADLINE_EXCEEDED,
  REJECTED_BY_THE_USER,
}
